<template>
<div>
  <!-- show all vue router informations -->
  <h1>404 - Not Found</h1>
  <p>Sorry, the page you are looking for does not exist.</p>
  <p>Vue Router current path: {{ $route.fullPath }}</p>
  <p>Vue Router current name: {{ $route.name }}</p>
  <p>Vue Router current params: {{ $route.params }}</p>
  <p>Vue Router current query: {{ $route.query }}</p>
  <p>Vue Router current hash: {{ $route.hash }}</p>
  <p>Vue Router current matched: {{ $route.matched }}</p>
  <p>Vue Router current meta: {{ $route.meta }}</p>
  <p>Vue Router current redirectedFrom: {{ $route.redirectedFrom }}</p>
  <p>Vue Router current path: {{ $route.path }}</p>
  <p>Vue Router current query: {{ $route.query }}</p>

</div>
</template>

<script>
export default {
  name: "NotFound"
}
</script>

<style scoped>

</style>
